<template>
  <div style="display: flex;flex:1">
    <!-- 解决因输入法框触发leave事件 隐藏popover框 -->
    <div v-if="visible" @mouseover="visible = false" class="menu-bg"></div>
    <div class="menu_content">
      <ul class="menu_box bg-color">
        <li
            @click="
            changeRouter(item,index);
            menuDisabled = true;
          "
            v-for="(item, index) in firstRouters"
            :key="index"
            :class="[activeNavIndex == index?'menu_li menu_li_active':'menu_li']"
        >
          <div class="card">
            <img
                class="mt5"
                :src="'/static/imgs/menu-dark/' + (item.icon || item.name) + '.png'"
                style="width: 30px; height: 30px"
                v-if=" theme=='light-theme' "
            />
            <img
                class="mt5"
                :src="'/static/imgs/menu-dark/' + (item.icon || item.name) + '.png'"
                style="width: 30px; height: 30px"
                v-if=" theme!='light-theme'  "
            />
          </div>
          <div class="mt5 menu_desc" :style="theme=='light-theme'?'color:#fff':''">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
    <div
        class="main_menu"
        @mouseenter="visible = true"
        style="position: relative;"
    >
      <el-popover
          v-model="visible"
          placement="bottom"
          width="350"
          trigger="manual"
      >
        <div>
          <el-row>
            <el-col :span="16">
              <el-input
                  v-model="query"
                  :placeholder="$t('按enter键搜索')"
                  @input="
                  page = 1;
                  queryData();
                "
                  icon="el-icon-search"
              />
            </el-col>
            <el-col :span="8" class="pd_l5">
              <el-button
                  v-show="buttonPageObj['projectList.createProject']"
                  type="primary"
                  @click="addProject()"
                  style="width: 100%; margin-left: 5px"
              ><i class="el-icon-tickets"></i>{{ $t("添加项目") }}
              </el-button>
            </el-col>
          </el-row>
          <ul class="let_ul mt5" style="display: flex; align-items: center">
            <li
                style="margin-left: 2px"
                :class="{ active: curLet == item.v }"
                @click="
                curLet = item.v;
                queryData(item.v);
              "
                v-for="(item, index) in letters"
                :key="index"
            >
              {{ item.k }}
            </li>
          </ul>
          <div v-if="itemList.length" class="outer_container">
            <div class="inner_container">
              <el-row
                  @click.native="
                  visible = false;
                  changeProject(item);
                "
                  class="proj_row"
                  v-for="(item, idx) in itemList"
                  :key="idx"
              >
                <el-col :span="6" style="position: relative">
                  <img
                      v-if="item.disks && item.disks[0]"
                      class="img_size"
                      v-lazy="item.disks[0]"
                  />
                  <i
                      v-else
                      class="el-icon-picture-outline"
                      style="font-size: 55px"
                  ></i>
                  <div
                      class="type-box"
                      :style="item.disks && item.disks[0] && 'top:0px'"
                  >
                    {{ item.typeName }}
                  </div>
                </el-col>
                <el-col :span="17" class="mt10">{{ item.name }}</el-col>
              </el-row>
              <!-- 修复：使用计算属性 host 代替 window.location.host -->
              <el-row
                  v-if="hostname === '121.31.75.173'||hostname === 'pcgsjc.cn'"
                  @click.native="visible = false; openNewUrl();"
                  class="proj_row"
              >
                <el-col :span="6" style="position: relative">
                  <img
                      class="img_size"
                      src="https://qiniu.bnerc.com/Fs9ARDQpGAJIJ8AZ4KfeseJqJgGY"
                  />
                  <div class="type-box" style="top:0px">边坡</div>
                </el-col>
                <el-col :span="17" class="mt10">平岑边坡监测</el-col>
              </el-row>
              <!-- 修复：使用计算属性 host 代替 window.location.host -->
              <el-row
                  v-if="hostname === '121.31.75.173'||hostname === 'pcgsjc.cn'"
                  @click.native="visible = false; openNewUrl2();"
                  class="proj_row"
              >
                <el-col :span="6" style="position: relative">
                  <img
                      class="img_size"
                      src="https://qiniu.bnerc.com/FhFYK7JwFMDKE9NT722RD1mOF0ph"
                  />
                  <div class="type-box" style="top:0px">除湿机</div>
                </el-col>
                <el-col :span="17" class="mt10">浔江除湿机监控</el-col>
              </el-row>
            </div>
            <div class="mt10" style="width: 100%; text-align: center">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-sizes="[10, 20, 30, 40, 60]"
                  :page-size="size"
                  layout="prev, pager, next"
                  :total="total"
              >
              </el-pagination>
            </div>
          </div>
          <div v-else>
            <no-data/>
          </div>
        </div>
        <span
            slot="reference"
            @click="visible = true"
            @mouseenter="visible = true"
        >{{
            projectInfo.name || $t("项目列表")
          }}<i class="el-icon-arrow-down ml5"></i
          ></span>
      </el-popover>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {
  imgBaseUrl,
  calcuMenu,
  goHome,
  routeWhiteList,
} from "@/utils/common.js";
import {getLastProjectId} from "@/utils/auth.js";

export default {
  data() {
    return {
      colorList: [
        "#00CCCC",
        "#3A67A5",
        "#DCC318",
        "#BE44EB",
        "#1E7CDB",
        "#73D13D",
        "#FC8352",
        "#0390A1",
        "#A9A9A9",
        "#6F4AC3",
        "#0F81A3",
      ],
      visible: false,
      menuDisabled: true,
      curLet: "",
      query: "",
      letters: [
        {k: "#", v: ""},
        {k: "A", v: "a"},
        {k: "B", v: "b"},
        {k: "C", v: "c"},
        {k: "D", v: "d"},
        {k: "E", v: "e"},
        {k: "F", v: "f"},
        {k: "G", v: "g"},
        {k: "H", v: "h"},
        {k: "I", v: "i"},
        {k: "J", v: "j"},
        {k: "K", v: "k"},
        {k: "L", v: "l"},
        {k: "M", v: "m"},
        {k: "N", v: "n"},
        {k: "O", v: "o"},
        {k: "P", v: "p"},
        {k: "Q", v: "q"},
        {k: "R", v: "r"},
        {k: "S", v: "s"},
        {k: "T", v: "t"},
        {k: "U", v: "u"},
        {k: "V", v: "v"},
        {k: "W", v: "w"},
        {k: "X", v: "x"},
        {k: "Y", v: "y"},
        {k: "Z", v: "z"},
      ],
      itemList: [],
      page: 1,
      size: 20,
      total: 0,
      activeNavIndex: 0
    };
  },
  computed: {
    ...mapGetters([
      "firstRouters",
      "secondRouters",
      "routerKeyData",
      "projectInfo",
      "buttonPageObj",
      "userInfo",
      'theme'
    ]),
    hostname() {
      return window.location.hostname;
    }
  },
  watch: {
    projectInfo() {
      if (this.projectInfo.id) {
        this.queryMenu();
      }
    },
    $route(newVal, oldVal) {
      let path = this.$route.path;
      if (this.$route.path == "/401") {
        path = this.$route.query.redirect;
      }
      let obj = this.getScondRouters(this.firstRouters, path);
      let secondRouters = obj.router;
      this.$store.commit("SET_SECONDROUTERS", secondRouters);
    },
  },
  created() {
    this.$Bus.$on("changeTheme", (theme) => {
      this.setThemeStore(theme)
    })

    if (!this.userInfo.name) {
      this.$store.dispatch("LogOut");
    }
    this.queryData().then((res) => {
      let lastProjectId = getLastProjectId(this.userInfo.id);
      this.getProjectInfoById(lastProjectId)
          .then((lastProjectInfo) => {
            if (!lastProjectInfo) {
              this.changeProject(this.itemList[0]);
            } else {
              this.changeProject(lastProjectInfo);
            }
          })
          .catch((res) => {
            this.changeProject(this.itemList[0]);
          });
    });
    this.$Bus.$on("setProjectInfo", (projectInfo) => {
      this.$store.dispatch("setProjectId", projectInfo);
    });
    this.$Bus.$on("createProj", (projInfo) => {
      this.itemList.push(projInfo);
      this.$store.dispatch("setProjectId", projInfo);
    });
    this.$Bus.$on("deleteProj", (id) => {
      this.queryData().then((res) => {
        let lastProjectId = getLastProjectId(this.userInfo.id);
        if (id == lastProjectId) {
          this.$store.commit("SET_ROUTERS", []);
          this.$store.commit("SET_SECONDROUTERS", []);
          this.$store.commit("SET_buttonPageObj", []);
          this.changeProject(this.itemList[0]);
        }
      });
    });
  },
  methods: {
    ...mapActions({
      setThemeStore: 'setThemeStore'
    }),
    openNewUrl() {
      window.open('http://gnssconfig.zlsk.xyz/autoLogin?token=OxNrHm0kiaDC4rls2mcp4%2F8JP46sF8Mr7E5xaYI5vXy5M1hDhfC9pRmDKLsPnQ0rhZlSd8anWN%2B5m%2BK6dY38fA%3D%3D')
    },
    openNewUrl2() {
      window.open('https://sdhj.dataserver.cn/dashboard/preview/202505gcc9412bF2iiGh8D7i0fHf7B68b15d7a19I/1_396fb38d-891b-49e0-9106-4db1b341b6f7_02f9443c-3c3a-4ae1-86f2-68c2079fc093_/1')
    },
    handleCurrentChange(page) {
      this.page = page;
      this.queryData();
    },
    handleSizeChange(size) {
      this.page = 1;
      this.size = size;
      this.queryData();
    },
    getScondRouters(treeData, redirectedFrom) {
      let router = null,
          routerName = "";
      treeData.forEach((item, index1) => {
        if (item.path.includes(redirectedFrom)) {
          routerName = item.code;
          router = item.children;
        }
        let factorsMenu = JSON.parse(
            localStorage.getItem(process.env.VUE_APP_NODE_ENV + "factorsMenu") ||
            "[]"
        );
        let obj = factorsMenu.find((it) => it.path == redirectedFrom);
        let isFactorInfoFlag = item.children.find((item) =>
            item.path.includes("factorInfo")
        );
        if (
            (item.code == "monitorInfo" && obj) ||
            (redirectedFrom.includes("/factorInfo") && isFactorInfoFlag)
        ) {
          routerName = item.code;
          router = item.children;
        }
        item.children.forEach((it, index2) => {
          if (it.path.includes(redirectedFrom)) {
            router = item.children;
            this.activeNavIndex = index1
          }
          it.children.forEach((i, index3) => {
            if (i.path.includes(redirectedFrom)) {
              router = item.children;
              routerName = i.code;
              this.activeNavIndex = index1
            }
          });
        });
      });
      this.$router.options.routes.forEach((item) => {
        if (redirectedFrom.includes(item.path)) {
          routerName = item.name;
        }
        item.children &&
        item.children.forEach((it) => {
          if (redirectedFrom.includes(it.path)) {
            routerName = it.name;
          }
        });
      });
      return {router: router, routerName: routerName};
    },
    queryMenu() {
      let factorList = [];
      let treeData = [];
      let factorRouterObj = {
        acoustic_emission: {
          code: "ds9",
          href: "/customized/ds9",
        },
        weigh: {
          code: "weighingMonitor",
          href: "/customized/weighingMonitor",
        },
        camera_video: {
          code: "videoMonitor",
          href: "/customized/videoMonitor",
        },
        key_monitor: {
          code: "projectMonitor",
          href: "/platform/projectMonitor",
        },
        temperature_control: {
          code: "temperature",
          href: "/customized/temperature",
        },
        group_preview: {
          code: "dataReport",
          href: "/platform/dataReport",
        },
      };
      this.$httpProj
          .get("/point/factor/getFactorsAndPoints")
          .then((data) => {
            data.data.forEach((item, index) => {
              item.id = item.id + "-" + index;
              let obj = factorRouterObj[item.specialCode];

              let activeName = "spotMonitor";
              if (["vibration", "dynamic"].includes(item.specialCode)) {
                activeName = "deviceMonitor";
              } else if (item.specialCode == "three_dimensional_displacement") {
                activeName = "beidouMonitor";
              }

              if (obj) {
                item.code = obj.code;
                item.href = obj.href;
              } else {
                item.code = "factorInfo";
                item.href =
                    "/platform/factorInfo/" +
                    activeName +
                    "/" +
                    item.id +
                    "/noGroup";
              }
              item.relateParams = item.relateParams || [];
              item.menus = item.relateParams.map((it) => {
                it.code = "factorInfo";
                it.href =
                    "/platform/factorInfo/" +
                    activeName +
                    "/" +
                    item.id +
                    "/" +
                    it.id;
                it.menus = [];
                return it;
              });
              if (item.menus && item.menus.length) {
                item.href = item.menus[0].href;
              }
            });
            factorList = data.data;
            return this.$httpSysMock.get(
                "auth/menu/findMenuByUserIdAndType?deviceType=pc&projectType=" +
                this.projectInfo.type
            );
          })
          .then((data) => {
            let obj = {};
            if (data.data.length) {
              let menus = data.data[0].menus;
              let projIndex = menus[0].menus.findIndex(
                  (item) => item.code == "monitorInfo"
              );
              if (projIndex != -1) {
                let monitormenuList = menus[0].menus[projIndex].menus;
                menus[0].menus[projIndex].menus = this.menuAndFactorOrder(monitormenuList, factorList)
                if (factorList.length == 0) {
                  menus[0].menus.splice(projIndex, 1);
                }
              }
              obj = calcuMenu(menus);
              treeData = (obj.routers[0] && obj.routers[0].children) || [];
            }

            this.$store.commit("SET_ROUTERS", treeData);
            this.$store.commit("SET_ROUTERKEYDATA", obj.keyData || {});
            return this.$httpSysMock.get(
                "/auth/menuOuter/findCodeAndRoleByProjectIdAndUserIdAndType?deviceType=pc&projectId=" +
                this.projectInfo.id +
                "&projectType=" +
                this.projectInfo.type
            );
          })
          .then((data) => {
            let pathList = data.data.codes || [];
            this.$store.commit("SET_buttonPageObj", pathList);
            this.calcuAuthority(treeData, pathList);
            this.operateRouterInfo(treeData);
          });
    },
    menuAndFactorOrder(monitormenuList, factorList) {
      const orderItems = monitormenuList
          .map(item => ({
            value: item.orderNum ? item.orderNum : 0,
            type: 'monitor',
            original: item
          }));
      const numItems = factorList
          .map(item => ({
            value: item.num ? item.num : 0,
            type: 'factor',
            original: item
          }));
      const merged = [...orderItems, ...numItems];
      let mergedList = merged.sort((a, b) => a.value - b.value);
      let menuList = mergedList.map(function (item) {
        return item.original;
      })
      return menuList;
    },
    operateRouterInfo(treeData) {
      this.$store.commit("SET_SECONDROUTERS", []);
      if (treeData.length) {
        let obj = this.getScondRouters(treeData, this.$route.path);
        let secondRouters = obj.router;
        this.$store.commit("SET_SECONDROUTERS", secondRouters);

        let {path} = this.$route,
            redirectRoute = this.$route.query.redirect;
        if (path == "/401" && redirectRoute) {
          obj = this.getScondRouters(treeData, redirectRoute);
          secondRouters = obj.router;
          this.$store.commit("SET_SECONDROUTERS", secondRouters);
          this.goLinkPage(redirectRoute);
        } else if (
            (path != "/" && secondRouters) ||
            (routeWhiteList.includes(path) && !path.includes("/customized"))
        ) {
          this.goLinkPage(path);
          this.$store.commit("SET_SECONDROUTERS", secondRouters);
        } else if (path == "/platform/location") {
          let link = goHome(this.projectInfo, this.buttonPageObj["location"]);
          this.goLinkPage(link);
        } else {
          let children = treeData[0].children;
          this.$store.commit("SET_SECONDROUTERS", children);
          if (children.length) {
            this.goLinkPage(children[0].path);
          } else {
            this.goLinkPage(treeData[0].path);
          }
        }
      } else {
        this.$router.push({path: "/401"});
      }
    },
    changeRouter(item, index) {
      this.activeNavIndex = index
      let path = item.path;
      if (item.children?.length) {
        if (item.children[0].children.length) {
          path = item.children[0].children[0].path;
        } else {
          path = item.children[0].path;
        }
      }
      this.goLinkPage(path);
    },
    addProject() {
      this.$store.commit("SET_SECONDROUTERS", []);
      this.$router.push({path: "/platform/createProject"});
    },
    changeProject(item) {
      item = item || {};
      this.$store.dispatch("setProjectId", item);
    },
    calcuAuthority(router, pathList) {
      router.forEach((item) => {
        this.routerKeyData[item.path].hasPromiss = true;
        if (
            !pathList.includes(item.path.split("/")[2]) &&
            !pathList.includes(item.code) &&
            !routeWhiteList.includes(item.code)
        ) {
          this.routerKeyData[item.path].hasPromiss = false;
        }
        this.calcuAuthority(item.children, pathList);
      });
    },
    goLinkPage(path, firstLink) {
      console.log('goLinkPage', path)
      let permissionObj = this.routerKeyData[path];
      let hasPermission = permissionObj ? permissionObj.hasPromiss : true;

      if (hasPermission || routeWhiteList.includes(path)) {
        this.$router.push({path: path});
      } else if (!hasPermission && !routeWhiteList.includes(path)) {
        this.$router.push({path: "/401", query: {redirect: path}});
      } else {
        if (firstLink && this.$route.path == "/") {
          let link = goHome(this.projectInfo);
          this.$router.push(link);
        } else {
          this.$router.push({
            path: path,
            query: {timeStrap: new Date().getTime()},
          });
        }
      }
    },
    getProjectInfoById(projectId) {
      if (!projectId) {
        return;
      }
      return new Promise((resolve, reject) => {
        this.$httpProj
            .get("proj/project/getByIdDetail?projectId=" + (projectId || ""))
            .then((data) => {
              resolve(data.data);
            })
            .catch((res) => {
              reject(res);
            });
      });
    },
    queryData(order) {
      let sendData = {
        pageObj: {
          current: this.page,
          size: this.size,
        },
        otherCondition: {name: this.query || "", pyHead: order},
        orderByCondition: {create_time: "desc"},
      };
      return new Promise((resolve, reject) => {
        this.$httpProj
            .post("/proj/project/projAndPicPage", sendData)
            .then((data) => {
              data.data.list.forEach((item) => {
                item.disks &&
                item.disks.forEach((it, idx) => {
                  if (it.thumbnail && !it.thumbnail.includes("http")) {
                    item.disks[idx] = imgBaseUrl + it.thumbnail;
                  }
                });
              });
              let {list, totalElements} = data.data;
              this.itemList = list;
              this.total = totalElements;
              resolve();
            });
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
/* 原样式保持不变，此处省略 */
.proj_row {
  cursor: pointer;
  margin-top: 5px;
}

.let_ul {
  width: 100%;
  height: 20px;

  li {
    width: 10px;
    height: 10px;
    line-height: 10px;
    margin-top: 5px;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
  }
}

.img_size {
  width: 50px;
  height: 50px;
}

.first_menu {
  margin: 0 20px;
}

.outer_container {
  position: relative;
  height: 420px;
  overflow: hidden;

  .inner_container {
    height: calc(100% - 45px);
    margin-right: -17px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}

.menu_content {
  margin-right: 10px;
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: space-around;

  .menu_box {
    height: 100%;
    overflow: auto;
  }
}

.menu_li {
  height: 100%;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  vertical-align: top;
  margin: 0 5px;
  padding: 0 5px;

  .card {
    width: 20px;
    height: 20px;
    margin: 5px auto 0;

    img {
      margin: 0;
      width: 100% !important;
      height: 100% !important;
    }
  }
}

.menu_li_active {
  background-color: #002d67;
}

.menu_desc {
  line-height: 25px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, \5fae\8f6f\96c5\9ed1, Arial, sans-serif;
}

.main_menu {
  font-weight: 600;
  font-size: 14px;
  height: 100%;
  cursor: pointer;
  margin-right: 10px;
  z-index: 99;
  display: flex;
  align-items: center;
}

.menu-bg {
  width: 100%;
  height: calc(100% - 50px);
  position: absolute;
  top: 0px;
  left: 0;
  background: rgba(255, 255, 255, 0);
  z-index: 9;
}

.light-theme .bg-color {
  background-color: transparent;
}

.light-theme .name {
  color: #fff;
}
</style>